import { NavLink, generatePath } from 'react-router-dom';
import {
  IconLoader,
  IconBatches,
  formatDate,
  ButtonPseudo,
  ButtonSize,
  IconLeft,
  IconRight,
} from '@ui/src';
import ROUTES from '../../routes';
import { ColumnBatchesTypes } from './types';
import ColumnHead from './column-head';

import cn from './column.module.css';

const ColumnBatches = ({
  count,
  sentBatches,
  bankId,
  accountId,
  isLoading,
  pagination,
  getNextPage,
}: ColumnBatchesTypes): React.JSX.Element => {
  let content: React.JSX.Element;

  if (isLoading) {
    content = (
      <div className={cn.columnLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <>
        {count > 0 && (
          <div className={`${cn.columnItemWrapper} ${cn.newBatchesWrapper}`}>
            <NavLink
              className={`${cn.columnItem} ${cn.badge}`}
              to={generatePath(ROUTES.EXPORT_BATCHES_ADD, {
                bankId: bankId as string,
                accountId: accountId as string,
              })}
            >
              <IconBatches className={cn.iconWrapper} />
              New batch ({count})
            </NavLink>
          </div>
        )}

        {sentBatches.length > 0 ? (
          <div className={cn.batchesWrapperContent}>
            <div className={cn.batchesTitle}>Sent</div>
            {sentBatches?.map((item) => (
              <div className={cn.columnItemWrapper} key={item.id}>
                <NavLink
                  className={`${cn.columnItem} ${cn.columnItemBatches}`}
                  to={generatePath(ROUTES.EXPORT_BATCHES_READ, {
                    bankId: bankId as string,
                    accountId: accountId as string,
                    batchId: item.id,
                  })}
                >
                  <div>{item.name}</div>
                  <div className={cn.columnItemDate}>
                    {formatDate(item.date || '', true)}
                  </div>
                </NavLink>
              </div>
            ))}
          </div>
        ) : (
          count === 0 && (
            <div className={`${cn.columnItem} ${cn.emptyBatches}`}>
              No transactions sent
            </div>
          )
        )}
      </>
    );
  }

  return (
    <div
      className={`${cn.column} ${cn.batchesColumn} ${
        isLoading ? cn.direction : ''
      }`}
    >
      <ColumnHead title="Batch No." />
      {content}
      <div className={cn.pagination}>
        <ButtonPseudo
          size={ButtonSize.SMALL}
          text="Prev"
          icon={<IconLeft />}
          className="button-white"
          disabled={!pagination?.hasPreviousPage || isLoading}
          onClick={() =>
            getNextPage && getNextPage(pagination?.startCursor as string, '-15')
          }
        />
        <ButtonPseudo
          size={ButtonSize.SMALL}
          text="Next"
          icon={<IconRight />}
          className={`button-white ${cn.buttonNext}`}
          disabled={!pagination?.hasNextPage || isLoading}
          onClick={() =>
            getNextPage && getNextPage(pagination?.endCursor as string, '15')
          }
        />
      </div>
    </div>
  );
};

export default ColumnBatches;
